import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from './Modal';
import i18n from '../utils/i18n';
import { resetModal } from '../actions/modalsActions';
import './styles/FeedbackModals.scss';

const FeedbackSentModal = ({ resetModal: reset }) => (
    <Modal
      isOpen={ true }
      onRequestClose={ reset }
      closeButtonText={ i18n.t('modals.feedback.SENT_DONE_BUTTON') }
      showActionButton={ false }
    >
      <div className="modal-container feedback-send-modal">
         <div className="feedback-send-icon">
             {i18n.t('modals.feedback.SENT_1ST_LINE')}<br/>
             {i18n.t('modals.feedback.SENT_2ND_LINE')}
         </div>
      </div>
    </Modal>
);

FeedbackSentModal.propTypes = {
  resetModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  modalData: state.modals.modalData
});

export default connect(mapStateToProps, { resetModal })(FeedbackSentModal);



// WEBPACK FOOTER //
// ./src/modals/FeedbackSentModal.js